export const DESK_SIDEBAR_WIDTH_LS_KEY = 'sidebar-width';
export const DESK_SIDEBAR_HIDDEN = 'desk-sidebar-hidden';
